import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFoundCharacter = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 162.8,
	height: 181.7,
	viewBox: "0 0 162.8 181.7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group 2085666273",
		children: [
			/* @__PURE__ */ _jsx("ellipse", {
				id: "Ellipse 7450",
				cx: 81.4,
				cy: 159.7,
				rx: 81.4,
				ry: 22,
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 7403",
				cx: 75.444,
				cy: 31.544,
				r: 31.544,
				fill: "url(#paint0_linear_0_53)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 240652104",
				x: 44.8617,
				y: 99.2,
				width: 27.587,
				height: 60.14,
				rx: 13.7935,
				transform: "rotate(15.7868 44.8617 99.2)",
				fill: "#4224ED"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 240652103",
				d: "M47.2001 125.535C43.7318 117.757 47.2261 108.639 55.0048 105.171V105.171C62.7835 101.703 71.9009 105.197 75.3691 112.976L88.928 143.386C92.3963 151.165 88.9019 160.282 81.1233 163.751V163.751C73.3446 167.219 64.2272 163.725 60.759 155.946L47.2001 125.535Z",
				fill: "url(#paint1_linear_0_53)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 240651956",
				width: 27.587,
				height: 56.821,
				rx: 13.7935,
				transform: "matrix(-0.744196 -0.667961 -0.667961 0.744196 135.384 75.827)",
				fill: "url(#paint2_linear_0_53)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 240652102",
				d: "M65.9191 80.8929C65.2889 74.5662 69.6626 68.831 75.9306 67.7649L102.79 63.1963C107.735 62.3553 112.685 64.6516 115.237 68.9694L117.693 73.127C127.366 89.4958 132.63 108.092 132.973 127.102L133.377 149.447C133.486 155.503 129.1 160.707 123.113 161.625L87.3102 167.116C80.4564 168.167 74.1229 163.255 73.4356 156.355L65.9191 80.8929Z",
				fill: "url(#paint3_linear_0_53)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 240651958",
				x: 63.9233,
				y: 62.9,
				width: 27.587,
				height: 56.821,
				rx: 13.7935,
				transform: "rotate(33.0918 63.9233 62.9)",
				fill: "url(#paint4_linear_0_53)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 240651954",
				x: 53.8,
				y: 30.7999,
				width: 4.13692,
				height: 13.445,
				rx: 2.06846,
				fill: "#252930"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_0_53",
			x1: 75.444,
			y1: 0,
			x2: 75.444,
			y2: 63.088,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .122808,
				stopColor: "#DAD4FF"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#C5BAFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_0_53",
			x1: 56.032,
			y1: 106.817,
			x2: 81.1271,
			y2: 163.101,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6247FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4F30FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_0_53",
			x1: 14.0331,
			y1: 1.70235,
			x2: 14.0331,
			y2: 56.297,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A797FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#8974FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_0_53",
			x1: 94.9205,
			y1: 66.1313,
			x2: 103.663,
			y2: 151.058,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#8974FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#6247FF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_0_53",
			x1: 77.9564,
			y1: 64.6023,
			x2: 77.9564,
			y2: 119.197,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A797FF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#8974FF"
			})]
		})
	] })]
});
export default SvgNotFoundCharacter;
